const AuthProvider = require('./provider');

/**
 * AuthProvider that doesn't add anything for auth. Useful for inabox testing.
 */
class NoAuthProvider extends AuthProvider {
  async injectAuth(httpReq) {}
}

module.exports = NoAuthProvider;
